import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-statement-account',
  templateUrl: './statement-account.component.html',
  styleUrls: ['./statement-account.component.scss']
})
export class StatementAccountComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
